/**
 * Envia uma mensagem de log para o servidor.
 * @param {string} level - O nível do log (ex: 'error', 'warn', 'info').
 * @param {string} message - A mensagem de log.
 * @param {object} [data={}] - Dados adicionais para o log.
 * @param {Error | any | null} [error=null] - O objeto de erro, ou nulo se não houver erro específico.
 */
export const logToServer = async (
  level: string,
  message: string,
  data: Record<string, unknown> = {},
  error: Error | unknown | null = null
): Promise<void> => {
  try {
    let errorPayload: { message: string; stack?: string; name?: string } | null = null
    if (error instanceof Error) {
      errorPayload = {
        message: error.message,
        stack: error.stack,
        name: error.name
      }
    } else if (error) {
      errorPayload = {
        message: String(error)
      }
    }

    await fetch('/api/logger', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        level,
        message,
        data,
        error: errorPayload
      })
    })
  } catch (fetchErr) {
    // eslint-disable-next-line no-console
    console.error('Falha ao enviar log para servidor:', fetchErr)
  }
}
